import { useEffect } from 'react';
import Link from '@/components/base/TransitionLink';
import Header from '@/components/feature/Header';
import Frame, { Section, SHELL, INSET_X, LINE } from '@/components/base/Frame';
import SectionLabel from '@/components/base/SectionLabel';
import { brand, navLinks } from '@/mocks/home';
import SectionLink from '@/components/base/SectionLink';
import ErrorBoundary from '@/components/base/ErrorBoundary';
import ConsultationForm from './components/ConsultationForm';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Contact — Discuss a Workflow | methodic';
  }, []);

  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Frame>
          <Section id="top" headerGap>
            <div className={`${SHELL} flex flex-1 flex-col`}>
              <div className="grid flex-1 grid-cols-1 lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)]">
                <div className={`flex flex-col border-b ${LINE} py-10 lg:border-b-0 lg:border-r lg:py-14 ${INSET_X}`}>
                  <SectionLabel index="01" label="Contact" />
                  <h1 className="mt-6 text-4xl font-light leading-[1.06] tracking-[-0.02em] text-foreground-950 lg:text-[52px]">
                    Bring us one workflow.
                  </h1>
                  <p className="mt-6 max-w-[26rem] text-base font-light leading-relaxed text-foreground-700">
                    Tell us what&rsquo;s slowing your team down. We&rsquo;ll explore how a better workflow could help.
                  </p>
                  <dl className={`mt-10 border-t ${LINE} font-label text-[11px] uppercase tracking-[0.12em] lg:mt-auto`}>
                    <div className={`flex justify-between border-b ${LINE} py-3`}><dt className="text-foreground-500">Reply</dt><dd className="text-foreground-900">Within 2 business days</dd></div>
                    <div className={`flex justify-between border-b ${LINE} py-3`}><dt className="text-foreground-500">Format</dt><dd className="text-foreground-900">30-min workflow review</dd></div>
                  </dl>
                </div>
                <div className={`py-10 lg:py-14 ${INSET_X}`}>
                  <div className="mx-auto w-full max-w-[560px]">
                    <ErrorBoundary>
                      <ConsultationForm />
                    </ErrorBoundary>
                  </div>
                </div>
              </div>
            </div>
          </Section>

          <footer className="pb-10 md:pb-14">
            <div className={`${SHELL}`}>
              <div className={`flex flex-col gap-6 border-y ${LINE} py-8 ${INSET_X} md:flex-row md:items-end md:justify-between`}>
                <div>
                  <Link to="/" className="cursor-target cursor-pointer text-lg text-foreground-950">
                    {brand.name}<span className="ml-1 font-light text-foreground-600">/</span>
                  </Link>
                  <p className="mt-2 text-sm text-foreground-700">{brand.descriptor}</p>
                  <p className="mt-4 font-label text-[11px] text-foreground-500">&copy; 2026 {brand.name}. All rights reserved.</p>
                </div>
                <nav className="flex flex-wrap gap-x-8 gap-y-2">
                  {navLinks.map((l) => (
                    <SectionLink key={l.href} section={l.href} className="cursor-target cursor-pointer whitespace-nowrap text-sm text-foreground-700 hover:text-primary-500">{l.label}</SectionLink>
                  ))}
                  {brand.linkedin && <a href={brand.linkedin} target="_blank" rel="noopener noreferrer" className="cursor-target cursor-pointer whitespace-nowrap text-sm text-foreground-700 hover:text-primary-500">LinkedIn</a>}
                </nav>
              </div>
            </div>
          </footer>
        </Frame>
      </main>
    </div>
  );
}